import React, { useMemo } from "react";
import usePageMeta from "../usePageMeta";
import useStructuredData from "../useStructuredData";
import AdSlot from "./AdSlot";

const SITE_URL = "https://hisaabtools.com";

// Shared layout for every calculator page:
// title + intro, the calculator itself (children), an ad slot, and a
// long-form SEO/content section (AdSense review requires substantial
// original content on each page — keep seoContent meaningful).
function CalculatorPage({ title, metaDescription, intro, children, seoContent }) {
  usePageMeta(`${title} – Hisaab Tools`, metaDescription);

  const pageUrl = `${SITE_URL}${window.location.pathname}`;
  const schema = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebApplication",
          name: title,
          description: metaDescription,
          url: pageUrl,
          applicationCategory: "UtilitiesApplication",
          operatingSystem: "Any (web browser)",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
          },
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: SITE_URL,
            },
            {
              "@type": "ListItem",
              position: 2,
              name: title,
              item: pageUrl,
            },
          ],
        },
      ],
    }),
    [title, metaDescription, pageUrl]
  );
  useStructuredData(schema);

  return (
    <main className="page">
      <div className="calc-card fade-in">
        <h1>{title}</h1>
        {intro && <div className="info-box">{intro}</div>}
        {children}
      </div>

      <AdSlot />

      {seoContent && <section className="seo-content">{seoContent}</section>}
    </main>
  );
}

export default CalculatorPage;
